import React from 'react'

import ServiceSetup from './ServiceSetup'

function ServiceSetupScreen() {
  return <ServiceSetup />
}

export default ServiceSetupScreen
